import {useState, useEffect} from 'react'

const FeedbackCard = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div>
      {/* Feedback Card - Compact Version */}
      <div
        className={`relative rounded-xl overflow-hidden border border-gray-800 bg-gray-900/70 backdrop-blur-xl shadow-lg transition-all duration-1000 ${
          isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
        }`}
      >
        {/* Top accent bar */}
        <div className="h-1 w-full bg-gradient-to-r from-indigo-500 via-purple-500 to-blue-500"></div>
        
        <div className="p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            {/* Feedback message */}
            <div className="flex items-center gap-2 text-gray-300">
              <svg className="w-5 h-5 text-purple-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-1.008c-.476.365-1.57.518-2.917.608C3.437 16.642 3.8 16.6 3 15c0 0 1.798-1.42 2-2-2.76-3.361-.32-8 4.978-8C13.418 3 18 6.134 18 10z" clipRule="evenodd"></path>
              </svg>
              <span className="text-sm sm:text-base font-medium">We'd love to hear your feedback!</span>
            </div>
            
            {/* Feedback button */}
            <a 
              href="https://docs.google.com/forms/d/e/1FAIpQLSeVxuO7V2q9dVA6zNTqsBZv5NmdZsTU-yErHBvCr16YO4-LTw/viewform?usp=header" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group relative inline-flex items-center justify-center px-5 py-2.5 overflow-hidden font-medium rounded-lg transition-all duration-300 hover:scale-105 focus:outline-none flex-shrink-0"
            >
              {/* Button background */}
              <span className="absolute inset-0 w-full h-full bg-gradient-to-br from-purple-600 to-blue-600"></span>
              
              {/* Hover effect */}
              <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></span>
              
              {/* Content */}
              <span className="relative flex items-center text-white text-sm font-bold">
                <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                </svg>
                Share Feedback
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedbackCard